import { DIMENSION_TAG } from '../dimension/createGroupBy';

const GEO_ISP = 'GEO_ISP';
const GEO_ASN = 'GEO_ASN';

export default (dimensionList, dimensionName, name, value) => {
  let dimensionField = null;
  let dimensionKey = null;
  // dimensionField might be changed when ASN is used to resolve ISP
  // track the originalField for creating filters
  // filters using the same originalField should be OR together
  let originalField = null;
  const dimension = dimensionList.find(originDimension => originDimension.name === dimensionName);

  if (dimension) {
    dimensionField = dimension.field;
    originalField = dimensionField;
    if (dimensionField === DIMENSION_TAG) {
      dimensionKey = dimension.groupBy;
    }
    if (dimensionField === GEO_ISP && !value.startsWith('isp:')) {
      dimensionField = GEO_ASN;
    }
  }
  return {
    field: dimensionField,
    key: dimensionKey,
    op: 'eq',
    value,
    display: name,
    originalField,
  };
};
